"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var mixitup_1 = __importDefault(require("mixitup"));
// @ts-ignore
var mixitup_pagination_min_js_1 = __importDefault(require("../../vendor/mixitup-pagination.min.js"));
var LoadmoreHandler_1 = __importDefault(require("../../helpers/LoadmoreHandler"));
var mixitupAnimation_1 = __importDefault(require("../../utilities/mixitupAnimation"));
exports.default = (function () {
    var feeds = Array.from(document.querySelectorAll('.Feed--filtering'));
    var loadmoreButton = document.querySelector('[data-loadmore]');
    feeds.forEach(function (feed) {
        var filteringElement = feed.querySelector('.Feed__container');
        if (!filteringElement) {
            return false;
        }
        var loadmoreButton = feed.querySelector('[data-loadmore]');
        var limit = loadmoreButton && loadmoreButton.dataset.loadmore ? parseInt(loadmoreButton.dataset.loadmore) : 15;
        var increment = limit % 2 === 0 ? 8 : 9;
        var args = {
            animation: mixitupAnimation_1.default,
            callbacks: {
                onMixEnd: function () { return updateLoadmore(); }
            }
        };
        if (loadmoreButton) {
            mixitup_1.default.use(mixitup_pagination_min_js_1.default);
            // @ts-ignore
            args.pagination = {
                limit: limit,
                hidePageListIfSinglePage: true
            };
        }
        var mixer = mixitup_1.default(filteringElement, args);
        var updateLoadmore = LoadmoreHandler_1.default(loadmoreButton, mixer, { limit: limit, increment: increment });
        var feedFilterGroup = feed.querySelector('.Feed__filterset');
        if (feedFilterGroup) {
            var feedFilterSelect_1 = Array.from(feedFilterGroup.querySelectorAll('select'));
            feedFilterGroup.addEventListener('change', function (e) {
                var newFilterString = feedFilterSelect_1.reduce(function (acc, currentValue) {
                    if (currentValue.value && currentValue.value !== 'all') {
                        acc += currentValue.value;
                    }
                    return acc;
                }, '');
                newFilterString = newFilterString ? newFilterString : 'all';
                mixer.filter(newFilterString);
            });
        }
    });
    // Edge case. If there is a loadmore button but no filtering.
    // if (!feeds.length && loadmoreButton) {
    //   loadmoreButton.style.display = 'none';
    // }
});
